<template>
    <div class="apprentice-simple-card">
        <div class="lp-category-description">
            <h3 class="title">{{ $t('learning_path.explanation_work_fields') }}</h3>
            <ckeditor
                v-model="description"
                :editor="editor"
                :config="editorConfig">
            </ckeditor>

            <div class="lp-category-actions">
                <b-button
                    class="btn-save btn-save-lp-category-description"
                    variant="primary"
                    @click="saveLpCategory">
                    {{ $t('common.save') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';

export default {
    name: 'design2021-learning-path-settings-component',
    props: {
        lpSettings: {
            type: Object,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            description: this.lpSettings ? this.lpSettings.description : '',
            editor: ApprenticeEditor,
            editorConfig: {
                placeholder: this.$t('common.description'),
                bodyClass: 'lp-category-description-content',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {
                    uploadUrl: this.routes.baseUrl() + '/image/upload',
                },
            },
        };
    },
    methods: {
        saveLpCategory() {
            const data = {
                description: this.description,
            };

            this.axios.post(this.routes.lpSettings(), data).then(
                (response) => {
                    this.alert.success();
                },

                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.lp-category-description ::v-deep {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .ck.ck-editor__main {
        height: 350px;

        > .ck.ck-editor__editable {
            height: 100%;
        }
    }

    .lp-category-actions {
        display: flex;
        justify-content: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}
</style>
